import React from "react";
import "./TextCard.css";
import "../App.css";

function TextCard({ imageUrl, title, text, subtitle, pullQuote, reverse }) {
	return (
		<section className="text-card-section">
			<div
				className={`text-card-container${
					reverse ? " text-card-container--reverse" : ""
				}`}>
				<div className="text-card-imagewrap">
					<img
						src={imageUrl}
						alt={subtitle || title || "Over ons"}
						className="text-card-image"
						loading="lazy"
					/>
				</div>
				<div className="text-card-content">
					{title && <span className="text-card-eyebrow">{title}</span>}
					{subtitle && <h2 className="text-card-title">{subtitle}</h2>}
					<div className="text-card-text">
						{text.split("\n\n").map((para, idx) => (
							<p key={idx}>
								{para.split("\n").map((line, i, arr) => (
									<React.Fragment key={i}>
										{line.trim()}
										{i < arr.length - 1 && <br />}
									</React.Fragment>
								))}
							</p>
						))}
					</div>
					{pullQuote && (
						<>
							<div className="text-card-divider" aria-hidden="true"></div>
							<p className="text-card-pullquote">{pullQuote}</p>
						</>
					)}
				</div>
			</div>
		</section>
	);
}

export default TextCard;
